// controllers/alerts_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    if (this.element.classList.contains("alert-success")) {
      setTimeout(() => {
        this.element.classList.remove("show");
        this.element.classList.add("fade");
      }, 1000);
    }
  }
}
